"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CartList_1 = __importDefault(require("../../Components/CartList"));
var CheckoutForm_1 = __importDefault(require("../../Components/CheckoutForm"));
var CheckoutSummary_1 = __importDefault(require("../../Components/CheckoutSummary"));
var CloseSquare_1 = require("@styled-icons/evaicons-solid/CloseSquare");
var moment_1 = __importDefault(require("moment"));
var Cart = __importStar(require("../../Actions/Cart"));
var StyledRibbonInner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"])));
var Coupon = function (props) {
  var isCouponApplied = props.isCouponApplied,
    usedCoupon = props.usedCoupon;
  var _a = react_1.useState(''),
    coupon = _a[0],
    setCoupon = _a[1];
  var _b = react_1.useState(false),
    loading = _b[0],
    setLoading = _b[1];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var handleCouponCodeChange = function (e) {
    var value = e.target.value;
    setCoupon(value);
  };
  var handleCouponUse = function (coupon) {
    return __awaiter(void 0, void 0, void 0, function () {
      var e_1, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);
            setLoading(true);
            return [4 /*yield*/, Cart.onUseCoupon(coupon)];
          case 1:
            _a.sent();
            return [3 /*break*/, 4];
          case 2:
            e_1 = _a.sent();
            response = e_1.response;
            if (response.error === 'invalid_coupon') {
              antd_1.message.error('不合法的優惠券');
            }
            if (response.error === 'usage_exceed') {
              antd_1.message.error('優惠券數量不足');
            }
            return [3 /*break*/, 4];
          case 3:
            setLoading(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var handleDiscardCoupon = function (e) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.stopPropagation();
            _a.label = 1;
          case 1:
            _a.trys.push([1,, 3, 4]);
            AppActions.setLoading(true);
            return [4 /*yield*/, Cart.fetchCart()];
          case 2:
            _a.sent();
            setCoupon('');
            return [3 /*break*/, 4];
          case 3:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement("div", null, react_1.default.createElement(antd_1.Input.Search, {
    placeholder: "\u8ACB\u8F38\u5165\u512A\u60E0\u5238\u4EE3\u78BC",
    value: coupon,
    onChange: handleCouponCodeChange,
    onSearch: handleCouponUse,
    loading: loading,
    enterButton: true,
    style: {
      width: 200,
      margin: '10px 0'
    }
  }), isCouponApplied && react_1.default.createElement(antd_1.Badge.Ribbon, {
    color: "red",
    text: react_1.default.createElement(StyledRibbonInner, {
      onClick: handleDiscardCoupon
    }, react_1.default.createElement("span", null, "\u512A\u60E0\u5238"), react_1.default.createElement(CloseSquare_1.CloseSquare, {
      size: 18
    }))
  }, react_1.default.createElement(antd_1.Card, {
    title: usedCoupon.name,
    size: "small"
  }, react_1.default.createElement(antd_1.Descriptions, null, react_1.default.createElement(antd_1.Descriptions.Item, {
    label: "\u512A\u60E0\u5238\u4EE3\u78BC"
  }, usedCoupon.code), react_1.default.createElement(antd_1.Descriptions.Item, {
    label: "\u512A\u60E0\u5238\u6298\u6263"
  }, usedCoupon.discount), react_1.default.createElement(antd_1.Descriptions.Item, {
    label: "\u512A\u60E0\u5238\u6D3B\u52D5\u671F\u9593"
  }, moment_1.default(usedCoupon.start_time).format('YYYY/MM/DD'), " ~", ' ', moment_1.default(usedCoupon.end_time).format('YYYY/MM/DD'))))));
};
function CheckoutReviewPage() {
  var _this = this;
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var isCouponApplied = cart.discount_items.some(function (i) {
    return i.type === 'coupon';
  });
  var usedCoupon = react_1.useMemo(function () {
    if (!isCouponApplied) {
      return null;
    }
    return cart.discount_items.find(function (i) {
      return i.type === 'coupon';
    }).coupon;
  }, [cart.discount_items, isCouponApplied]);
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  function checkAllowNextStep(cart) {
    var addressFields = cart.receiver_zip && cart.receiver_city && cart.receiver_district && cart.receiver_address && cart.buyer_zip && cart.buyer_city && cart.buyer_district && cart.buyer_address;
    var commonCheckFields = cart.items.length > 0 && cart.payment_subtype && cart.logistics_type && cart.buyer_name && cart.buyer_phone && cart.buyer_email && cart.receiver_name && cart.receiver_phone && cart.receiver_email;
    if (cart.logistics_type === Cart.LOGISTICS_TYPE.cvs) {
      return commonCheckFields && !!cart.logistics_cvs_store_id;
    } else {
      return commonCheckFields && addressFields;
    }
  }
  var handleCheckout = function () {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            AppActions.setLoading(true);
            return [4 /*yield*/, AppActions.delay(600)];
          case 1:
            _a.sent();
            return [4 /*yield*/, Cart.checkoutRequest(usedCoupon === null || usedCoupon === void 0 ? void 0 : usedCoupon.code)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _a.sent();
            console.warn(ex_1);
            AppActions.setLoading(false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(antd_1.Card, null, react_1.default.createElement(antd_1.PageHeader, {
    title: "\u8FD4\u56DE",
    onBack: function () {
      return AppActions.navigate('/checkout/info');
    },
    style: {
      padding: 0
    }
  }), react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u8CFC\u7269\u8ECA"), cart.items.length === 0 && react_1.default.createElement("div", null, react_1.default.createElement("h3", {
    style: {
      margin: '10px 0'
    }
  }, "\u60A8\u76EE\u524D\u7684\u8CFC\u7269\u8ECA\u70BA\u7A7A!"), react_1.default.createElement(antd_1.Button, {
    onClick: function () {
      return AppActions.navigate('/products');
    }
  }, "\u99AC\u4E0A\u9078\u8CFC")), react_1.default.createElement(CartList_1.default, {
    cartItems: cart.items,
    disabled: true
  }), react_1.default.createElement(CheckoutForm_1.default, {
    disabled: true,
    style: {
      marginTop: 30
    }
  }), react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u512A\u60E0\u5238"), react_1.default.createElement(Coupon, {
    isCouponApplied: isCouponApplied,
    usedCoupon: usedCoupon
  }), react_1.default.createElement(CheckoutSummary_1.default, {
    cart: cart,
    disabled: !checkAllowNextStep(cart),
    onClick: handleCheckout,
    buttonLabel: "\u7D50\u5E33"
  })));
}
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"])));
exports.default = CheckoutReviewPage;
var templateObject_1, templateObject_2;